import { render, staticRenderFns } from "./ExamDesign.vue?vue&type=template&id=3a46ebb4&scoped=true"
import script from "./ExamDesign.vue?vue&type=script&lang=js"
export * from "./ExamDesign.vue?vue&type=script&lang=js"
import style0 from "./ExamDesign.vue?vue&type=style&index=0&id=3a46ebb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a46ebb4",
  null
  
)

export default component.exports